"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const styled_1 = tslib_1.__importStar(require("@eduzz/houston-styles/styled"));
const nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
const Caption_1 = tslib_1.__importDefault(require("./Caption"));
const Heading_1 = tslib_1.__importDefault(require("./Heading"));
const Paragraph_1 = tslib_1.__importDefault(require("./Paragraph"));
const Subtitle_1 = tslib_1.__importDefault(require("./Subtitle"));
const Typography = React.forwardRef((_a, ref) => {
    var { as: Tag = 'p', className } = _a, props = tslib_1.__rest(_a, ["as", "className"]);
    return (0, jsx_runtime_1.jsx)(Tag, Object.assign({ ref: ref, className: className }, props));
});
const TypographyWrapper = (0, styled_1.default)(Typography) `
  ${({ theme, size = 'xxs', lineHeight = 'md', weight = 'regular', color = 'neutralColor.low.pure', marginBottom }) => {
    function getColor(color) {
        if (color === 'inherit') {
            return 'inherit';
        }
        if (color === 'primary') {
            return theme.brandColor.primary.pure;
        }
        const [themeColor, level, variable] = color.split('.');
        return theme[themeColor][level][variable];
    }
    return (0, styled_1.css) `
      margin: 0;
      font-size: ${theme.font.size[size]};
      font-weight: ${theme.font.weight[weight]};
      line-height: ${theme.line.height[lineHeight]};
      color: ${getColor(color)};

      ${marginBottom &&
        (0, styled_1.css) `
        margin-bottom: ${theme.spacing.nano};
      `}
    `;
}}
`;
exports.default = (0, nestedComponent_1.default)(TypographyWrapper, {
    Caption: Caption_1.default,
    Heading: Heading_1.default,
    Paragraph: Paragraph_1.default,
    Subtitle: Subtitle_1.default
});
